import axios from "axios";
import type { LegalPartnerData } from "./registerLegalPartner.d";

const registerLegalPartner = async (data: LegalPartnerData) => {
  const url = "/api/register-legal-partner/";

  const headers = {
    "Content-Type": "application/json",
  };

  try {
    return await axios.post(url, data, { headers });
  } catch (error) {
    return Promise.reject(error);
  }
};

export default registerLegalPartner;
